import * as React from "react";
import { Biller } from "./billerCategoryTypes";
import Grid, { GridProps } from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SelectCategoryModal from "./SelectCategoryModal";
import { groupAuth } from "app/utils/authGroups";
import Typography from "@material-ui/core/Typography";

type Props = {
  biller: Biller | null;
  refetch?: Function;
};

type State = { editingCategory: boolean };

class GridKey extends React.Component<GridProps> {
  render() {
    return (
      <Grid item={true} md={2} xs={12} {...this.props}>
        {this.props.children}
      </Grid>
    );
  }
}

class GridValue extends React.Component<GridProps> {
  render() {
    return (
      <Grid item={true} md={4} xs={12} {...this.props}>
        {this.props.children}
      </Grid>
    );
  }
}

export default class EditBillerContainer extends React.Component<Props, State> {
  state = { editingCategory: false };
  static defaultProps = {
    biller: null,
  };

  onClickSetCategory = () => {
    this.setState({ editingCategory: true });
  };

  onCloseModal = (options = { refetchData: false }) => {
    this.setState({ editingCategory: false });
    if (options.refetchData && !!this.props.refetch) {
      this.props.refetch();
    }
  };

  renderBillerInfo(b: Biller) {
    return !!b ? (
      <Grid alignItems="center" container={true} spacing={24}>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Name:</b>
        </GridKey>
        <GridValue>{b.name}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Provider:</b>
        </GridKey>
        <GridValue>{b.provider}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Idenfifier:</b>
        </GridKey>
        <GridValue> {b.identifier} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Placeholder:</b>
        </GridKey>
        <GridValue>{b.placeholder}</GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Last Updated:</b>
        </GridKey>
        <GridValue> {b.updated_at} </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Tag ancestry:</b>
        </GridKey>
        <GridValue style={{ display: "flex", justifyContent: "flex-start" }}>
          {" "}
          {b.category_list.map((tag, index) => {
            const drawArrow = index < b.category_list.length - 1;
            return (
              <Typography key={index}>
                <b>{tag}</b>
                {drawArrow ? ">" : null}
              </Typography>
            );
          })}{" "}
        </GridValue>
        <GridKey>
          <b style={{ fontWeight: 400 }}>Logo:</b>
        </GridKey>
        <GridValue style={{ display: "flex" }}>
          {b.logo ? (
            <div style={{ flex: "0 0 25%" }}>
              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: 0,
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                  alt="Message"
                  src={b.logo}
                />
              </div>
            </div>
          ) : (
            "N/A"
          )}
        </GridValue>
      </Grid>
    ) : (
      <Typography>Loading...</Typography>
    );
  }

  render() {
    return (
      <section>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            borderBottom: "1px solid #aaa",
            alignItems: "flex-end",
            marginBottom: "20px",
          }}
        >
          <h1 style={{ margin: 0 }}>Biller Info</h1>
          <Button
            color="primary"
            onClick={() => this.onClickSetCategory()}
            disabled={
              !this.props.biller || !groupAuth.hasAccessGroup(["Ops/Admin"])
            }
          >
            Set Category
          </Button>
        </div>
        {this.renderBillerInfo(this.props.biller)}
        <SelectCategoryModal
          biller={this.state.editingCategory ? this.props.biller : null}
          onClose={this.onCloseModal}
        />
      </section>
    );
  }
}
